import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription, first } from 'rxjs';
import { SiteService } from '../../services/site.service';
import { getQueryParamFromAncestorRoute } from '../../utilities/route.utilities';
import { MasonryItemModel } from '../masonry/masonry.component';
import { BeyondEmergencyCreditItemComponent } from '../widgets/beyond-emergency-credit-item.component';
import { IssuesEmergencyFreqGridItemComponent } from './grid-item/payg/issues-emergency-freq-grid-item.component';
import { IssuesHighBalanceGridItemComponent } from './grid-item/payg/issues-high-balance-grid-item.component';
import { IssuesLoanGridItemComponent } from './grid-item/payg/issues-loan-grid-item.component';
import { IssuesNoCommunicationGridItemComponent } from './grid-item/payg/issues-no-communication-grid-item.component';
import { IssuesNoPaymentsGridItemComponent } from './grid-item/payg/issues-no-payments-grid-item.component';
import { DataService } from '../../services/data.service';

@Component({
    selector: 'issues-payg',
    templateUrl: './issues-payg.component.html'
})
export class IssuesPaygComponent implements OnInit, OnDestroy {

    masonryItems: MasonryItemModel[] = [];
    subscriptions: Subscription[] = [];
    clientId: number;
    selectedSiteId: number = 0;
    userSiteId: number = 0;
    sites: any[] = [];

    constructor(private route: ActivatedRoute,
        private router: Router,
        private siteService: SiteService,
        private dataService: DataService) { }

    ngOnInit() {
        this.masonryItems = [
            {
                component: BeyondEmergencyCreditItemComponent,
                isExpandable: true
            },
            {
                component: IssuesEmergencyFreqGridItemComponent,
                isExpandable: true
            },
            {
                component: IssuesHighBalanceGridItemComponent,
                isExpandable: true
            },
            {
                component: IssuesLoanGridItemComponent,
                isExpandable: true
            },
            {
                component: IssuesNoCommunicationGridItemComponent,
                isExpandable: true
            },
            {
                component: IssuesNoPaymentsGridItemComponent,
                isExpandable: true
            }
        ];

        // update isExpandable per item, if data is resolved
        this.dataService.beyondEmergencyCreditItemComponentResolved.pipe(first()).subscribe(
            result => this.masonryItems.find(x => x.component == BeyondEmergencyCreditItemComponent).isExpandable = result
        )
        this.dataService.issuePaygEmergencyCreditFrequencyDetailResolved.pipe(first()).subscribe(
            result => this.masonryItems.find(x => x.component == IssuesEmergencyFreqGridItemComponent).isExpandable = result
        )
        this.dataService.issuesHighBalanceGridItemComponentResolved.pipe(first()).subscribe(
            result => this.masonryItems.find(x => x.component == IssuesHighBalanceGridItemComponent).isExpandable = result
        )
        this.dataService.issuesLoanGridItemComponentResolved.pipe(first()).subscribe(
            result => this.masonryItems.find(x => x.component == IssuesLoanGridItemComponent).isExpandable = result
        )
        this.dataService.issuesNoCommunicationGridItemComponentResolved.pipe(first()).subscribe(
            result => this.masonryItems.find(x => x.component == IssuesNoCommunicationGridItemComponent).isExpandable = result
        )
        this.dataService.issuesNoPaymentsGridItemComponentResolved.pipe(first()).subscribe(
            result => this.masonryItems.find(x => x.component == IssuesNoPaymentsGridItemComponent).isExpandable = result
        )

        this.userSiteId = parseInt(getQueryParamFromAncestorRoute(this.route, 'siteId'));

        this.subscriptions.push(this.route
            .parent!
            .parent!
            .params
            .subscribe(params => {
                this.clientId = +params['clientId'];
                this.search();
            }));

        if (Number.isNaN(this.userSiteId) || this.userSiteId === undefined) { this.userSiteId = 0; }

        this.selectedSiteId = this.userSiteId;
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    search() {
        this.siteService.all(this.clientId).then((result) => {
            this.sites = result;
            this.selectedSiteId
        });
    }

    updateSite() {
        let queryParams: any = JSON.parse(JSON.stringify(this.route.snapshot.queryParams)) as any;
        if (this.selectedSiteId != undefined && this.selectedSiteId != null) {
            queryParams.siteId = +this.selectedSiteId;
        }
        this.router.navigate(['/portal/' + this.clientId.toString() + '/issues/payg'], {
            queryParams: queryParams,
            replaceUrl: true
        }).then(result => {
            this.ngOnDestroy();
            this.ngOnInit();
        });
    }
}
